<div *ngIf="subArea" class="container-fluid">
  <div class="row">
    <div *ngIf="subArea.subArea_ID">
      <div mat-dialog-title i18n>Edit Sub Area</div>
      <p i18n>Make the necessary changes on the form below then click Submit</p>
    </div>
    <div *ngIf="!subArea.subArea_ID">
      <div mat-dialog-title i18n>Add Sub Area</div>
      <p i18n>To add a new Sub Area, complete the form below then click Submit.</p>
    </div>
    <div class="float-right warning" i18n>* Required Information</div>
  </div>
  <form #form="ngForm" (ngSubmit)="saveSubArea(form)">
    <div mat-dialog-content>
      <div class="form-group form-inline">
        <span class="warning">* </span>
        <label class="col-form-label mr-3" for="area_ID" i18n>Area</label>
        <div>
          <select [(ngModel)]="subArea.area_ID" name="area_ID" id="areaId" class="form-control select-bidit" required #area="ngModel">
            <option [ngValue]="undefined" selected="">-</option>
            <option *ngFor="let area of areas" [(ngValue)]="area.area_ID">{{area.area_Name}}</option>
          </select>
          <div [hidden]="!form.submitted || area.valid"
               class="alert alert-danger" i18n>Area is required</div>
        </div>
      </div>
      <div class="form-group form-inline">
        <span class="warning">* </span>
        <label class="col-form-label mr-3" for="name" i18n>Sub Area Name</label>
        <div>
          <input id="name" name="name" class="form-control" maxlength="100" width="100" [(ngModel)]="subArea.subArea_Name"
                 required #name="ngModel"
                 [class.field-error]="form.submitted && name.invalid">
          <div [hidden]="!form.submitted || name.valid"
               class="alert alert-danger" i18n>Sub Area Name is required</div>
        </div>
      </div>
      <div id="divLaborCost">
        <div class="row p-2 bg-calculate">
          <div class="col">
            <label class="text-bidit-primary font-weight-bold" i18n>Calculate Labor Cost</label>
            <p class="text-bidit-primary" i18n>
              Enter Labor and Piece Rate
              and click calculator to
              display Labor Cost below.
            </p>
          </div>
          <div class="col">
            <label for="laborRate" i18n>Labor Rate <br />($ per Hour)</label>
            <input id="laborRate" type="number" name="laborRate" class="form-control" [(ngModel)]="laborRate">
          </div>
          <div class="col">
            <label for="pieceRate" i18n>Piece Rate <br />(Sq Ft per Hour)</label>
            <input id="pieceRate" type="number" name="pieceRate" class="form-control" [(ngModel)]="pieceRate">
          </div>
          <div class="mt-4 pr-2">
            <img (click)="calcLaborCost()" src="assets/img/circle_images/quotes_circle.png" alt="Calculate Icon" />
          </div>
        </div>
      </div>
      <div class="form-group form-inline mt-3">
        <span class="warning">* </span>
        <label class="mr-3" for="laborCost" i18n>Labor Cost</label>
        <div>
          <div class="form-inline">
            <input id="laborCost" type="number" step="any" min="0" name="laborCost" class="form-control" [(ngModel)]="subArea.subArea_LaborCost"
                   required #laborCost="ngModel"
                   [class.field-error]="form.submitted && laborCost.invalid">
            <label class="ml-3">(Per Sq Ft)</label>
          </div>
          <div [hidden]="!form.submitted || laborCost.valid"
               class="alert alert-danger" i18n>Labor Cost is required</div>
        </div>
      </div>
    </div>

    <mat-dialog-actions align="end">
      <button type="submit" value="submit" name="submit" id="submit" [disabled]="isRequesting" class="btn btn-bidit-submit btn-md mr-3" i18n>Submit</button>
      <a (click)="onNoClick()" class="btn btn-bidit-cancel btn-md" i18n>Cancel</a>
    </mat-dialog-actions>
    <app-spinner [isRunning]="isRequesting"></app-spinner>

    <div class="mt-3">
      <div [hidden]="!form.submitted || form.valid"
           class="alert alert-danger" i18n>Validation issues encountered.  Please review your entered information.</div>
    </div>
  </form>
</div>
